function setValue(el, value) {
    if (isInputOrTextAreaElement(el)) {
        el.value = value;
    } else {
        el.textContent = value;
    }
}
export function getValue(el): string {
    return isInputOrTextAreaElement(el) ? el.value : el.textContent;
}
export function insertValue(el, start, end, text, iframe, noRecursion = false) {
    if (isTextElement(el)) {
        const val = getValue(el);
        setValue(
            el,
            val.substring(0, start) + text + val.substring(end, val.length)
        );
        setCaretPosition(el, start + text.length, iframe);
    } else if (!noRecursion) {
        const selObj = getWindowSelection(iframe);
        if (selObj && selObj.rangeCount > 0) {
            const selRange = selObj.getRangeAt(0);
            const position = selRange.startOffset;
            const anchorNode = selObj.anchorNode;
            insertValue(anchorNode, position - (end - start), position, text, iframe, true);
        }
    }
}
export function isInputOrTextAreaElement(el): boolean {
    return el !== null && (el.nodeName === 'INPUT' || el.nodeName === 'TEXTAREA');
}

export function isTextElement(el): boolean {
    return el !== null && (el.nodeName === 'INPUT' || el.nodeName === 'TEXTAREA' || el.nodeName === '#text');
}

export function setCaretPosition(el, pos, iframe = null) {
    if (isInputOrTextAreaElement(el) && el.selectionStart) {
        el.focus();
        el.setSelectionRange(pos, pos);
    } else {
        const range = getDocument(iframe).createRange();
        range.setStart(el, pos);
        range.collapse(true);
        const sel = getWindowSelection(iframe);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
export function getCaretPosition(el, iframe = null): number {
    if (isInputOrTextAreaElement(el)) {
        const val = el.value;
        return val.slice(0, el.selectionStart).length;
    } else {
        const selObj = getWindowSelection(iframe);
        if (selObj.rangeCount > 0) {
            const selRange = selObj.getRangeAt(0);
            const preCaretRange = selRange.cloneRange();
            preCaretRange.selectNodeContents(el);
            preCaretRange.setEnd(selRange.endContainer, selRange.endOffset);
            const position = preCaretRange.toString().length;
            return position;
        }
    }
}

function getDocument(iframe) {
    if (!iframe) {
        return document;
    } else {
        return iframe.contentWindow.document;
    }
}
function getWindowSelection(iframe) {
    if (!iframe) {
        return window.getSelection();
    } else {
        return iframe.contentWindow.getSelection();
    }
}
export function getContentEditableCaretCoords(ctx) {
    const markerTextChar = '\ufeff';
    const markerId = 'sel_' + new Date().getTime() + '_' + Math.random().toString().substr(2);
    const doc = getDocument(ctx ? ctx.iframe : null);
    const sel = getWindowSelection(ctx ? ctx.iframe : null);
    const prevRange = sel.getRangeAt(0);
    // create new range and set postion using prevRange
    const range = doc.createRange();
    range.setStart(sel.anchorNode, prevRange.startOffset);
    range.setEnd(sel.anchorNode, prevRange.startOffset);
    range.collapse(false);
    // Create the marker element containing a single invisible character
    // using DOM methods and insert it at the position in the range
    const markerEl = doc.createElement('span');
    markerEl.id = markerId;
    markerEl.appendChild(doc.createTextNode(markerTextChar));
    range.insertNode(markerEl);
    sel.removeAllRanges();
    sel.addRange(prevRange);
    const coordinates = {
        left: 0,
        top: markerEl.offsetHeight
    };
    localToRelativeCoordinates(ctx, markerEl, coordinates);
    markerEl.parentNode.removeChild(markerEl);
    return coordinates;
}
function localToRelativeCoordinates(ctx, element, coordinates) {
    let obj = element;
    let iframe = ctx ? ctx.iframe : null;
    while (obj) {
        if (ctx.parent !== null && ctx.parent === obj) {
            break;
        }
        coordinates.left += obj.offsetLeft + obj.clientLeft;
        coordinates.top += obj.offsetTop + obj.clientTop;
        obj = obj.offsetParent;
        if (!obj && iframe) {
            obj = iframe;
            iframe = null;
        }
    }
    obj = element;
    iframe = ctx ? ctx.iframe : null;
    while (obj !== getDocument(null).body && obj !== null) {
        if (ctx.parent !== null && ctx.parent === obj) {
            break;
        }
        if (obj.scrollTop && obj.scrollTop > 0) {
            coordinates.top -= obj.scrollTop;
        }
        if (obj.scrollLeft && obj.scrollLeft > 0) {
            coordinates.left -= obj.scrollLeft;
        }
        obj = obj.parentNode;
        if (!obj && iframe) {
            obj = iframe;
            iframe = null;
        }
    }
}
